export const Logo = () => {
    return <div className="bg-blend-multiply">
        <img className="w-[60px]" src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754494658359878668_689376c2.webp"></img>
        </div>
}